import { Steps } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import LayoutComponent from '../../../../components/LayoutComponent/LayoutComponent';
import { ProjectMemberImport, TaskMember } from '../../../../model/entities';
import { ProviderType } from '../../../../model/types';
import styles from './ImportPage.module.scss';
import ResultComponent from './ResultComponent/ResultComponent';
import SummaryComponent from './SummaryComponent/SummaryComponent';
import UploadComponent from './UploadComponent/UploadComponent';

/**
 * Returns the project members import page.
 * @returns the project members import page.
 */
const ImportPage = (): React.ReactElement => {
    /*** HOOKS ***/
    const params = useParams<ParamsType>();
    const [step, setStep] = useState<number>(0);
    const [projectMemberImport, setProjectMemberImport] = useState<ProjectMemberImport>();
    const [task, setTask] = useState<TaskMember>();

    /*** EFFECTS ***/

    /*** METHODS ***/

    const showProjectMemberImport = (projectMemberImport: ProjectMemberImport) => {
        const step = 1;
        setProjectMemberImport(projectMemberImport);
        setStep(step);
    };

    const showResults = (result: TaskMember) => {
        const step = 2;
        setTask(result);
        setStep(step);
    };

    const back = () => {
        const stepUpdated = step - 1;
        setStep(stepUpdated);
    };

    /*** COMPONENTS ***/

    return (
        <LayoutComponent pageId="projectMembers">
            <h1 className={styles.title}>
                <FormattedMessage id="projectMembers.import.title" />
            </h1>
            <Steps
                current={step}
                className={styles.steps}
                items={[
                    { title: <FormattedMessage id="projectMembers.import.steps.1" /> },
                    { title: <FormattedMessage id="projectMembers.import.steps.2" /> },
                    { title: <FormattedMessage id="projectMembers.import.steps.3" /> },
                ]}
            />
            <div hidden={step !== 0}>
                <UploadComponent hubId={params.hubId} onLoadProjectMemberImport={showProjectMemberImport} />
            </div>
            {step === 1 && projectMemberImport && (
                <SummaryComponent projectMemberImport={projectMemberImport} onSaveMembers={showResults} onBack={back} />
            )}
            {step === 2 && task && <ResultComponent task={task} />}
        </LayoutComponent>
    );
};

export default ImportPage;

type ParamsType = { provider: ProviderType; hubId: string };
